import './menu.scss';



/** WEBPACK FOOTER **
 ** ./components/Menu/menu.js
 **/